import PayrollIncomeComponents from "../components/PayrollIncome";
import useIncomeDeductionList from "../hooks/useIncomeDeductionList";

import { PAGE_TYPE } from "../schemas/incomeDeductionSchema";

const PayrollIncome = () => {
  const useIncomeDeductionListProps = useIncomeDeductionList({
    pageType: PAGE_TYPE.INCOME,
  });
  return <PayrollIncomeComponents {...useIncomeDeductionListProps} />;
};

export default PayrollIncome;
